import {SODeleteIngest} from '../../core/ingest/so-delete-ingest';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteIngest extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteIngest;
}